import React from 'react';
import _CopyRight from './_CopyRight.scss'

class CopyRight extends React.Component {

  render() {
    return (
      <div className='copyright-container'>
        <p className="title-social">SÀN THƯƠNG MẠI ĐIỆN TỬ TỈNH ĐẮK LẮK</p>
        <p className='footer-description'>Đơn vị chủ quản: TRUNG TÂM KHUYẾN CÔNG VÀ XÚC TIẾN THƯƠNG MẠI ĐẮK LẮK</p>
        <p className='footer-description'>Địa chỉ: 18 Lý Thái Tổ, Phường Tân An, tỉnh Đắk Lắk</p>
        <p className='footer-description'>Điện thoại: 0262 3641 888</p>
        <p className='footer-description'>Email: <a href="mailto:socongthuong@daklak.gov.vn">socongthuong@daklak.gov.vn</a></p>
        <p className='footer-description'>Người đại diện: Ngô Văn Tượng - Giám đốc Trung tâm</p>
        <p className='footer-description'>Quyết định Thành lập Trung tâm Khuyến công và Xúc tiến Thương mại Đắk Lắk số: 1212/QĐ-UBND</p>
        <p className='footer-description'>Ngày cấp: 04/06/2025 - Nơi cấp: Ủy Ban Nhân Dân tỉnh Đắk Lắk</p>
      </div>
    );
  }
}
export default CopyRight;



// WEBPACK FOOTER //
// ./components/layouts/master/sub-footer/CopyRight.jsx